import { IconButton, styled, useTheme } from '@mui/material';
import { useAppDispatch } from '../../../app/hooks';
import { UploadDetail } from '../../../services/entities/impl/blfApi/schemas/uploadSummary';
import TooltipPopup from '../../commonUI/tooltips/TooltipPopup';
import { DebugIcon } from '../../navbar/components/icons/DebugIcon';
import { setDebugCurrCollectionId, setDebugOpen } from '../debugSlice';
import { TooltipUploadDetail } from './tooltips/TooltipUploadDetail';

type Props = {
  collectionId: string;
  uploadDetail?: UploadDetail;
};

export const CollectionDebugLauncher = ({
  collectionId,
  uploadDetail,
}: Props) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const handleClick = () => {
    dispatch(setDebugOpen(true));
    dispatch(setDebugCurrCollectionId(collectionId));
  };

  return (
    <TooltipPopup
      colorScheme='extraDark'
      placement='right'
      popupComponent={
        <TooltipUploadDetail
          collectionId={collectionId}
          uploadDetail={uploadDetail}
        />
      }
      customBgColor={theme.vars.palette.background.paper}
      border
      arrow={false}
    >
      <StyledIconButton size='small' onClick={handleClick}>
        <DebugIcon />
      </StyledIconButton>
    </TooltipPopup>
  );
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.vars.palette.text.secondary,
  padding: 0,
}));
